var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-range-select"},_vm._l((_vm.items),function(item,index){return _c('span',{key:index,staticClass:"item",class:{ active: item.type === _vm.value },on:{"click":function($event){return _vm.onClick(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }